// test2123
(2123 && 0);
